module.exports = __webpack_public_path__ + "img/zlifeWhite.6db24220.png";